module.exports = __webpack_public_path__ + "static/part-of-team-93f38403b1b0886e2129e854c4a8c5e2.jpg";